export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/stylus-8d8721fccbbf6354d182a43bb1270067.jpg";